import { css } from 'styled-components';
import {
  getSpacing, SpacingName, ThemedFunctor, rgba,
} from '@doveit/lego';

export const content: ThemedFunctor = ({
  theme,
}) => css`
  table {
    width: 100%;
  }

  table:first-child {
    ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
  }

  table:not(:first-child) {
    ${getSpacing.marginTop(theme, SpacingName.SMALL)}
  }

  thead {
    background-color: ${rgba(theme.palettes.brand.primary, 0.9)};
    color: ${theme.palettes.neutrals.lightest};
  }

  tbody {
    tr:nth-child(odd) {
      background-color: ${theme.palettes.neutrals.lighter};
    }
  }

  th,
  td {
    ${getSpacing.padding(theme, SpacingName.SMALLER)}
    text-align: left;
  }
`;
